export default "__VITE_ASSET__4fcae2c0__"